import { render } from "./UnLockedIcon.vue?vue&type=template&id=1cc5e426&ts=true"
import script from "./UnLockedIcon.vue?vue&type=script&lang=ts"
export * from "./UnLockedIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__